import { createFileRoute } from '@tanstack/react-router'

import DetailSwastaPage from '@/components/pages/backoffice/_ktg-penyuluh/swasta/_swastaId/containers/DetailSwastaPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/swasta/$swastaId/'
)({
  component: DetailSwastaPage
})
